import React from 'react'

import BaseSkeleton from '../BaseSkeleton'
import Card from '../../../Card'

import { TransactionSummaryCardSkeletonProps } from './TransactionSummaryCardSkeleton.types';

const TransactionSummaryCardSkeleton: React.FC<TransactionSummaryCardSkeletonProps> = ({className}) => {
  return (
    <Card className={`relative flex flex-justify p4 ${className}`}>
     <div className="flex flex-column">
          <BaseSkeleton width={120} height={25} className="mb2" />
          <BaseSkeleton width={120} height={25} className="mb2" />
          <BaseSkeleton width={120} height={25} className="mb2" />
          <BaseSkeleton width={120} height={25} className="mb2" />
          <BaseSkeleton width={120} height={25} />
        </div>
        <div className="flex flex-column">
          <BaseSkeleton width={50} height={25} className="mb2 mt4" />
          <BaseSkeleton width={50} height={25} className="mb2" />
          <BaseSkeleton width={50} height={25} className="mb2" />
          <BaseSkeleton width={50} height={25} />
        </div>
    </Card>
  )
}

export default TransactionSummaryCardSkeleton;
export { TransactionSummaryCardSkeletonProps };